import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPrint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 16.07H3a2 2 0 0 1-2-2V6.076a2 2 0 0 1 2-2h2M4 16.07v1.006a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V16.07m-14 0v-3.994a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3.994M5 4.076v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2m-12 0h12m0 0h2a2 2 0 0 1 2 2v7.994a2 2 0 0 1-2 2h-1m.008-9.005h-2"
      stroke="#007AFF"
    />
  </svg>
);
const Memo = memo(SvgPrint);
export default Memo;
